module.exports = __webpack_public_path__ + "img/gcs.d064c2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/gcs.png
// module id = sdld
// module chunks = 39 44